import { ComponentWithPermissions } from '../../../../../../../../../../baseComponents/CreateRoutering/types'
import { ModalFlexible } from '../../../../../../../../../../baseComponents/Modal'
import { UseEditDeleteModalProps } from '../../../../../../../../../../utils/hooks/useEditDeleteModal'
import { PdfConfigTemplateTabProps } from '../../../types'
import CPTModalCreate from './CPTModalCreate'
import CPTModalEdit from './CPTModalEdit'
import { PdfConfigAllModulesVariablesByType, PdfConfigSingleModuleVariables } from '../../../../types'
import { useState } from 'react'
import { RectangularInput } from '../../../../../../../../../../forms/Input'
import CopyToClipboard from 'react-copy-to-clipboard'
import { changeSuccessMessage } from '../../../../../../../../../../utils/reducers/reduxDispatch'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { ModulePdfConfigParent } from './types'
import useModulesTranslations from '../../../../../../../../../../utils/hooks/useModulesTranslations'
const companyAndWorkingCenterTypes = ['companyName', 'companyAddress', 'company_IdNumber', 'company_phone', 'company_mobile', 'companyAddress_additional', 'companyAddress_postalCode', 'companyAddress_city', 'companyAddress_country', 'WorkingCenterId', 'WorkingCenterAddress', 'WorkingCenterAddress_additional', 'WorkingCenterAddress_postalCode', 'WorkingCenterAddress_city', 'WorkingCenterAddress_country', 'WorkingCenter_idNumber', 'WorkingCenter_phone', 'WorkingCenter_mobile']
const defaultOrderTypes = [...companyAndWorkingCenterTypes, 'assigned_number', 'finished_date', 'processed_date', 'finished_date_complete', 'processed_date_complete', 'version', 'shipment_method', 'is_last', 'status', 'typeShipping', 'notes', 'total_subtotalCosts', 'total_subtotalProducts', 'total_subtotal', 'total_discounts_before', 'total_discounts_before_per_row', 'total_discounts_after', 'total_without_vat', 'total_vat', 'total_vat2', 'total_total', 'total_to_pay', 'total_payed', 'SpecificPriceRuleIds', 'CreateEmployeeId', 'ProcessEmployeeId', 'CurrencyId', 'CustomerId', 'Customer_Name', 'Customer_FullName',  'Customer_Fiscal_Name', 'Customer_IdNumber', 'CustomerAddress', 'CustomerAddress_additional', 'CustomerAddress_postalCode', 'CustomerAddress_city', 'CustomerAddress_country', 'OrderShippingId', 'ShippingAddress', 'ShippingAddress_additional', 'ShippingAddress_postalCode', 'ShippingAddress_city', 'ShippingAddress_country', 'OrderShipping_finalPriceWithTax', 'OrderShipping_finalPriceWithoutTax', 'RepresentativeEmployee_name', 'RepresentativeEmployee_fullNameShort', 'RepresentativeEmployee_fullNameLong', 'RepresentativeEmployee_email', 'RepresentativeEmployee_phone', 'RepresentativeEmployee_mobile', 'FirstFinancialRowQuantity', 'FirstFinancialRowType', 'signature', 'PaymentMethod_name']
const defaultVoucherTypes = [...companyAndWorkingCenterTypes, 'CustomerId', 'Customer_Name', 'Customer_FullName', 'Customer_Fiscal_Name', 'Customer_IdNumber', 'voucher_n', 'amount', 'amount_simple', 'reuses', 'CurrencyId', 'usedAmount', 'usedAmount_simple', 'VoucherId', 'createdAt', 'createdAt_complete']
const defaultTicketTypes = [...defaultOrderTypes, 'total_subtotal_simple', 'total_discounts_before_simple', 'total_vat_simple', 'total_vat2_simple', 'total_total_simple', 'total_payed_simple', 'total_to_pay_simple', 'total_subtotal_after', 'total_subtotal_after_simple']
const defaultCashTypes = [...companyAndWorkingCenterTypes, 'assigned_number', 'createdAt', 'endDate', 'OpenEmployee_name', 'OpenEmployee_fullNameShort', 'CloseEmployee_fullNameShort', 'CloseEmployee_name', 'notes', 'totalPayment', 'totalQuantity', 'totalPaymentSells', 'totalPaymentRefund', 'totalQuantityRefund', 'totalVat', 'totalVat2', 'totalWithoutVat', 'totalVatSells', 'totalVat2Sells', 'totalWithoutVatSells', 'totalVatRefund', 'totalVat2Refund', 'totalWithoutVatRefund']
const defaultProductCertificate = ['createdAt', 'Product_Reference', 'Product_Secondary_Reference', 'Product_Name', 'Product_Description', 'Product_Short_Description', 'Product_CodeBar', 'Product_Image', 'Product_Weight', 'Product_Price' ]
export const recursiveCashTypes = {
    'PaymentMethodCopyDates': ['PaymentType_name', 'totalPayment', 'totalQuantity', 'totalPaymentSells', 'totalPaymentRefund', 'totalQuantityRefund']
}

export const recursiveOrderTypes = {
    'Products': ['OrderId', 'assigned_number', 'CustomerId', 'Customer_Code', 'CurrencyId', 'orderDate', 'ProductId', 'product_notes', 'delivery_date', 'quantity', 'minQuantity', 'isPack', 'packQuantities', 'typeQuantity', 'label', 'discount', 'taxUsed', 'taxUsed2', 'unique_number', 'initialUnitPriceWithoutTax', 'finalUnitPriceWithoutTax', 'rowPriceWithoutTaxPrev', 'rowPriceWithoutTaxAndTotalDiscount', 'rowPriceWithoutTax', 'rowPriceWithTax', 'finalUnitPriceWithTax', 'extraLineDiscountRow', 'extraLineDiscount', 'extraLineRecharge', 'totalWithoutTaxWithComplements', 'totalWithTaxWithComplements', 'totalWithoutTaxWithComplementsPrev', 'totalWithoutTaxWithComplementsCompensed', 'unitPriceWithComplements', 'Product_Reference', 'Product_Secondary_Reference', 'Product_Name', 'Product_Description', 'Product_Short_Description', 'Product_CodeBar', 'Product_Image', 'nLine', 'ChapterId', 'Chapter_Name', 'OrderAddonGroupId', 'rowPriceWithoutTaxAndCompensatoryValue', 'rowPriceWithoutTaxPrevAndCompensatoryValue', 'compensatoryValuePrev', 'initialUnitPriceWithTax'],
    'Costs': ['Cost_Name', 'costPriceWithoutTax', 'costPriceWithTax', 'costTaxUsed', 'costTotalTax'],
    'Chapters': ['Chapter_Name', 'Chapter_Description', 'total_subtotalCosts', 'total_subtotalProducts', 'total_subtotal', 'total_discounts_before', 'total_discounts_before_per_row', 'total_discounts_after', 'total_without_vat', 'total_vat', 'total_vat2', 'total_total', 'total_recharge_before', 'total_recharge_after', 'OrderId', 'ChapterId'],
    'FinancialRows': ['FinancialRow_id', 'position', 'quantityFinancialRow', 'financialRowType'],
    'PaymentMethodCopyDates': ['PayMCopyDate_date', 'PayMCopyDate_quantity', 'PaymentType_name'],
    'vat': ['subTotalAfter', 'subTotalAfter_simple', 'vatMoney', 'vatMoney_simple', 'vatMoney2', 'vatMoney2_simple', 'total', 'total_simple', 'taxUsed', 'taxUsed2', 'taxUsed_simple', 'taxUsed2_simple','retentionMoney']
}
export const recursiveTicketTypes = {
    'Products': [...recursiveOrderTypes['Products'], 'quantity_simple', 'rowPriceWithTax_simple', 'initialUnitPriceWithTax_simple', 'finalUnitPriceWithTax_simple', 'totalWithTaxWithComplements_simple'],
    'FinancialRows': [...recursiveOrderTypes['FinancialRows']],
    'PaymentMethodCopyDates': [...recursiveOrderTypes['PaymentMethodCopyDates'], 'PayMCopyDate_quantity_simple', 'PayMCopyDate_change', 'PayMCopyDate_customerMoney', 'PayMCopyDate_change_simple', 'PayMCopyDate_customerMoney_simple'],
    'vat': [...recursiveOrderTypes['vat']],
}

const getModulesByType: PdfConfigAllModulesVariablesByType = {
    'buyOrder': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes
    },
    'buyDeliveryNote': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes
    },
    'buyInvoice': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes
    },
    'quoteOrder': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes
    },
    'sellOrder': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes
    },
    'sellDeliveryNote': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes
    },
    'sellInvoice': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes
    },
    'ticket': {
        'Logo': [],
        'Table': defaultTicketTypes,
        'Text': defaultTicketTypes,
        'TableRecursive': recursiveTicketTypes,
        'DrawLine': [],
        'PrintBarcode': defaultTicketTypes,
        'PrintQR': defaultTicketTypes
    },
    'sellRefundInvoice': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes
    },
    'sellRefundDeliveryNote': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes
    },
    'ticketPDF': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes,
        'PrintBarcode': defaultOrderTypes,
        'PrintQR': defaultOrderTypes
    },
    'ticketRefundPDF': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes,
        'PrintBarcode': defaultOrderTypes,
        'PrintQR': defaultOrderTypes
    },
    'customerMaterialStockOrder': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes,
    },
    'ticketRefund': {
        'Logo': [],
        'Table': defaultTicketTypes,
        'Text': defaultTicketTypes,
        'TableRecursive': recursiveTicketTypes,
        'DrawLine': [],
        'PrintBarcode': defaultTicketTypes,
        'PrintQR': defaultTicketTypes
    },
    'voucher': {
        'Logo': [],
        'Table': defaultVoucherTypes,
        'Text': defaultVoucherTypes,
        'TableRecursive': [],
        'DrawLine': [],
        'PrintBarcode': defaultVoucherTypes,
        'PrintQR': defaultVoucherTypes
    },
    'voucherPDF': {
        'Logo': [],
        'Table': defaultVoucherTypes,
        'Text': defaultVoucherTypes,
        'TableRecursive': [],
        'DrawLine': [],
        'PrintBarcode': defaultVoucherTypes,
        'PrintQR': defaultVoucherTypes
    },
    'giftTicket': {
        'Logo': [],
        'Table': defaultTicketTypes,
        'Text': defaultTicketTypes,
        'TableRecursive': recursiveTicketTypes,
        'DrawLine': [],
        'PrintBarcode': defaultTicketTypes,
        'PrintQR': defaultTicketTypes
    },
    'giftTicketPDF': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes,
        'PrintBarcode': defaultOrderTypes,
        'PrintQR': defaultOrderTypes
    },
    'adjustmentDeliveryNote': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes,
        'PrintBarcode': defaultOrderTypes,
        'PrintQR': defaultOrderTypes
    },
    'manufacturingPDF': {
        'Logo': [],
        'Table': defaultOrderTypes,
        'Text': defaultOrderTypes,
        'TableRecursive': recursiveOrderTypes,
        'PrintBarcode': defaultOrderTypes,
        'PrintQR': defaultOrderTypes
    },
    'cashRegister': {
        'Logo': [],
        'Table': defaultCashTypes,
        'Text': defaultCashTypes,
        'TableRecursive': recursiveCashTypes,
        'PrintBarcode': defaultCashTypes,
        'PrintQR': defaultCashTypes
    },
    'reparation': {
    },
    'warehouseTransfer': {
    },
    'ticketReparation': {
    },
    'productCertificate': {
        'Logo': [],
        'Table': defaultProductCertificate,
        'Text': defaultProductCertificate,
        'PrintBarcode': defaultProductCertificate,
        'PrintQR': defaultProductCertificate
    },
}

type CPTCEModalProps = PdfConfigTemplateTabProps & ComponentWithPermissions & {
    modifyKey: number
}

const CPTCEModal: React.FC<CPTCEModalProps> = ({ setOpenModal, openModal, ...toModal }) => {
    const {myModule, setMyModule} = useCPTCEModalLogic({openModal})
    const modalType = toModal.config.type
    if (!modalType) {
        return null
    }
    const moduleVars = getModulesByType[modalType]
    let renderThis: JSX.Element | null = <CPTModalCreate {...{ ...toModal, setOpenModal, openModal, myModule: myModule.component, setMyModule }} modules={moduleVars} />
    if (openModal?.type === 'edit' && myModule.component) {
        renderThis = <CPTModalEdit {...{ ...toModal, setOpenModal, openModal, setMyModule }} moduleVars={moduleVars[myModule.component] || []} />
    }
    let myModuleVars: any = []
    if (myModule.component && moduleVars[myModule.component]) {
        myModuleVars = moduleVars[myModule.component] || []
        if (myModule.recursiveElement && myModuleVars[myModule.recursiveElement] ) {
            myModuleVars = myModuleVars[myModule.recursiveElement]
        }
    }
    const moduleBarRequired = myModule.component && myModuleVars?.length
    return (
        <ModalFlexible setOpened={() => setOpenModal(null)} opened={true} className='flex flex-col' type={moduleBarRequired ? 'modal_extrabig' : 'modal_medium'} >
            <div className='flex-auto flex h-1'>
                {moduleBarRequired ? <ModuleBarVariables moduleVars={myModuleVars} /> : null}
                {renderThis}
            </div>
        </ModalFlexible>
    )
}

interface CPTCEModalLogicProps {
    openModal: UseEditDeleteModalProps
}

const useCPTCEModalLogic = ({openModal}: CPTCEModalLogicProps) => {
    const [myModule, setMyModule] = useState<ModulePdfConfigParent>({ component: openModal?.allRowData?.component || null, recursiveElement: openModal?.allRowData?.extraProps?.recursiveElement })
    
    return {myModule, setMyModule}
}

interface ModuleBarVariablesProps {
    moduleVars: PdfConfigSingleModuleVariables
}

const ModuleBarVariables: React.FC<ModuleBarVariablesProps> = ({ moduleVars }) => {
    const { defaultOrderTypesDict } = useModulesTranslations()
    const {t} = useTwinTranslation()
    const renderThis: JSX.Element[] = []
    if(Array.isArray(moduleVars)){
        for (const element of moduleVars) {
            const translation = defaultOrderTypesDict[element];
            let myElement = '{' + element + '}'
            renderThis.push(
                <div className='config_pdf_moduleVariablesTable_row flex items-center'>
                    <div>{translation}</div>
                    <div className='relative'>
                        <CopyToClipboard text={myElement} onCopy={() => changeSuccessMessage(t('copiedToClipboard', 'Copiado al portapapeles'))}>
                            <div className='absolute top-0 right-0 bottom-0 left-0 cursor-pointer'>
                            </div></CopyToClipboard>
                        <RectangularInput value={myElement} readOnly={true} disabled={true} />
                    </div>
                </div>
            )
        }
    }
    return (
        <div className='config_pdf_moduleVariables negative-margin'>
            <div className='config_pdf_moduleVariablesTable'>
                {renderThis}
            </div>
        </div>
    )
}



export default CPTCEModal